import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import { fetchLastSalesData } from "../../../redux/reducers/apiSlice";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import PaginatedTable from "../../components-bootstrap/PaginatedTable";
import { BodyBuilder } from "../../../exports/Images";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import {
  convertStraight,
  convertThenFormat,
  formatDateTimezon,
} from "../../common-data/Converts";
import PayoutsTable from "../../components-bootstrap/PayoutsTable";

const LastSales = ({ sendableQPs, decryptedText }) => {
  const dispatch = useDispatch();
  const { salesLoading, lastSalesData } = useSelector((state) => state.api);
  const [lastSales, setLastSales] = useState([]);
  const [isPage, setIsPage] = useState(0);
  const [pagination, setPagination] = useState([]);
  const [saleModal, setSaleModal] = useState(false);
  const iniModValues = {
    isModOpen: false,
    cardType: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  const closeModalValues = () => {
    setModValues(iniModValues);
  };

  useEffect(() => {
    if (sendableQPs) {
      dispatch(
        fetchLastSalesData({
          queryParameters: sendableQPs,
          token: decryptedText?.token,
          pageNo: isPage + 1,
          limit: 5,
        })
      );
    }
  }, [isPage, sendableQPs]);

  useEffect(() => {
    if (lastSalesData?.status && lastSalesData?.data?.length > 0) {
      setLastSales(lastSalesData.data);
      setPagination(lastSalesData?.pagination);
    } else {
      setLastSales([]);
      setPagination([]);
    }
  }, [lastSalesData]);

  const tbColumns = [
    {
      dataField: "trainer_name",
      text: "Trainer Name/Profile",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer">
          <img
            src={row?.trainer_profile || BodyBuilder}
            alt={row?.trainer_name || "N/A"}
            className="image"
          />
          <p
            className="name"
            style={{
              cursor: "pointer",
              minWidth: "200px",
              margin: "0",
              lineHeight: "normal",
            }}
          >
            {row?.trainer_name || "N/A"}
            <br />
            <small style={{ color: "gray" }}>{row?.gym_name || ""}</small>
          </p>
        </div>
      ),
    },
    {
      dataField: "member_name",
      text: "member name",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info ">{row?.member_name || "N/A"}</p>
        </div>
      ),
    },
    // {
    //   dataField: "gym_name",
    //   text: "Gym",
    //   formatter: (cell, row) => (
    //     <div className="emeberDetailsRowContainer column">
    //       <p className="info minWidth150">{row?.gym_name || "N/A"}</p>
    //     </div>
    //   ),
    // },
    {
      dataField: "session_status",
      text: "session",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info ">{row?.session_status || "0"}</p>
        </div>
      ),
    },
    // {
    //   dataField: "no_of_session",
    //   text: "sessions",
    //   formatter: (cell, row) => (
    //     <div className="emeberDetailsRowContainer column">
    //       <p className="info ">{row?.no_of_session || "0"}</p>
    //     </div>
    //   ),
    // },
    // {
    //   dataField: "consumed_session",
    //   text: "consumed session",
    //   formatter: (cell, row) => (
    //     <div className="emeberDetailsRowContainer column">
    //       <p className="info">{row?.consumed_session || "0"}</p>
    //     </div>
    //   ),
    // },
    // {
    //   dataField: "price",
    //   text: "price",
    //   formatter: (cell, row) => (
    //     <div className="emeberDetailsRowContainer column">
    //       <p className="info ">₹{row?.price || "0"}</p>
    //     </div>
    //   ),
    // },
    {
      dataField: "duration",
      text: "duration",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info ">{row?.duration || "0"}</p>
        </div>
      ),
    },
    // {
    //   dataField: "price",
    //   text: "Amount/(Online,Cash)",
    //   formatter: (cell, row) => (
    //     <div className="emeberDetailsRowContainer column">
    //       <p className="info minWidth150 bold">
    //         {row?.is_partial === "true"
    //           ? `₹${convertThenFormat(
    //               row?.total_partial_price || 0
    //             )} / ${convertThenFormat(row?.price || 0)}`
    //           : `₹${convertThenFormat(row?.price || 0)}`}
    //         <br />
    //         <small style={{ fontWeight: "500" }}>
    //           (₹
    //           {convertThenFormat(
    //             row?.is_partial === "true"
    //               ? row?.partial_total_online
    //               : row?.total_online || 0
    //           )}{" "}
    //           /{" "}
    //           {convertThenFormat(
    //             row?.is_partial === "true"
    //               ? row?.partial_total_cash
    //               : row?.total_cash || 0
    //           )}
    //           )
    //           <br />
    //           {row?.plan_name || ""}
    //         </small>
    //       </p>
    //     </div>
    //   ),
    // },
    {
      dataField: "plan_name",
      text: "plan name",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.plan_name || "NA"}</span>;
      },
    },
    {
      dataField: "is_partial",
      text: "Payment Type",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className={`info ${row?.is_partial === "true" ? "link" : ""}`}
            onClick={() =>
              row?.is_partial === "true"
                ? setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    cardType: "partial_details",
                    partialDetails: row?.payment_details || [],
                  }))
                : null
            }
          >
            {row?.is_partial === "true" ? "Partial" : "Full"}
          </p>
        </div>
      ),
    },
    {
      dataField: "price",
      text: "Total Amount",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info bold">₹{convertThenFormat(row?.price || 0)}</p>
        </div>
      ),
    },
    {
      dataField: "total_partial_price",
      text: "Partial Amount",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info bold">
            {row?.is_partial === "true"
              ? `₹${convertThenFormat(row?.total_partial_price || 0)}`
              : "-"}
          </p>
        </div>
      ),
    },
    {
      dataField: "total_online",
      text: "Online Amount",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info bold">
            ₹
            {convertThenFormat(
              row?.is_partial === "true"
                ? row?.partial_total_online
                : row?.total_online || 0
            )}
          </p>
        </div>
      ),
    },
    {
      dataField: "total_cash",
      text: "Cash Amount",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info bold">
            ₹
            {convertThenFormat(
              row?.is_partial === "true"
                ? row?.partial_total_cash
                : row?.total_cash || 0
            )}
          </p>
        </div>
      ),
    },
    // {
    //   dataField: "level",
    //   text: "level",
    //   formatter: (cell, row) => (
    //     <div className="emeberDetailsRowContainer column">
    //       <p className="info ">{row?.level || "N/A"}</p>
    //     </div>
    //   ),
    // },
    // {
    //   dataField: "weekdays",
    //   text: "weekdays",
    //   formatter: (cell, row) => (
    //     <div className="emeberDetailsRowContainer column">
    //       <p className="info ">{row?.weekdays || "N/A"}</p>
    //     </div>
    //   ),
    // },
    {
      dataField: "subscription_status",
      text: "Subscription Status",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="info"
            style={{
              background:
                row?.subscription_status === "active" ? "#B4E7B9" : "#F6EFEF",
              color:
                row?.subscription_status === "active" ? "#0A701B" : "#F13434",
              borderRadius: "8px",
              padding: "5px 10px",
            }}
          >
            {row?.subscription_status || "N/A"}
          </p>
        </div>
      ),
    },
  ];

  const pmInfoColumns = [
    {
      dataField: "payment_created",
      text: "Payment Created",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.payment_created
              ? formatDateTimezon(row.payment_created)
              : "-"}
          </span>
        );
      },
    },
    {
      dataField: "date",
      text: "Schedule Date",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.date ? convertStraight(row.date) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "amount",
      text: "Amount",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.amount || 0) || 0}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius8"
            style={{
              background:
                row?.status === "pending"
                  ? "#FFEDC0"
                  : row?.status === "completed"
                  ? "#B4E7B9"
                  : "#F3DADA",
              color:
                row?.status === "pending"
                  ? "#171717"
                  : row?.status === "completed"
                  ? "#0A701B"
                  : "#D90000",
              borderRadius: "10px",
            }}
          >
            {row?.status || "NA"}
          </span>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={saleModal}
        onRequestClose={() => setSaleModal(false)}
        contentLabel="Assigned Member"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer incentiveHostoryModalContainer">
          <ModalHeadAndClose title="" onClose={() => setSaleModal(false)} />

          <div
            className="tabsPayoutsContainer allPtMemTabs"
            style={{ padding: "0", width: "100%" }}
          >
            <div className="allPtMembersTableContainer">
              <PaginatedTable
                columnsValues={tbColumns}
                dataValues={lastSales}
                paginationData={pagination}
                isPage={isPage}
                setIsPage={setIsPage}
              />
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        onRequestClose={closeModalValues}
        ariaHideApp={false}
        isOpen={modValues.isModOpen}
      >
        <div className={`${"createNewCTOModalContainer"}`}>
          <ModalHeadAndClose
            title={modValues.cardType?.replace(/_/g, " ")}
            onClose={closeModalValues}
          />

          {modValues.cardType === "partial_details" ? (
            <div className="fullWidthFlexCenter separatedTable">
              <PayoutsTable
                dataValues={modValues.partialDetails}
                columnsValues={pmInfoColumns}
              />
            </div>
          ) : null}
        </div>
      </Modal>

      <div
        className="settlementGraphContainer spanThree"
        style={{
          cursor: "pointer",
          justifyContent: "flex-start",
        }}
        onClick={() =>
          lastSales?.length > 0 ? setSaleModal(true) : setSaleModal(false)
        }
      >
        <div className="settleGraphTitleAndFilter">
          <h5 className="tite">Last 5 Sales</h5>
        </div>

        {salesLoading ? (
          <ReactVortoxSpinner />
        ) : (
          <div
            className="settleGraphBody"
            style={{ marginTop: "20px", cursor: "pointer" }}
          >
            {lastSales?.length > 0 ? (
              lastSales?.map((sale, index) => (
                <div className="cardBodyRow" key={index}>
                  <span className="name planName bgYellow">
                    {sale?.plan_name || "NA"}
                  </span>
                  <span className="name trainerName">
                    {sale?.trainer_name || "NA"}
                  </span>
                  <span className="name saleAmount">
                    ₹{convertThenFormat(sale?.price) || 0}
                  </span>
                  <span
                    className="name planStatus"
                    style={{
                      color:
                        sale?.subscription_status === "active"
                          ? "#379C00"
                          : "#C40C0C",
                    }}
                  >
                    {sale?.subscription_status || "NA"}
                  </span>
                </div>
              ))
            ) : (
              <span className="noDataFound mt-3">No Data Found!</span>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default LastSales;
